/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputPositionStockStatisticsItem } from './OutputPositionStockStatisticsItem';
import {
    OutputPositionStockStatisticsItemFromJSON,
    OutputPositionStockStatisticsItemFromJSONTyped,
    OutputPositionStockStatisticsItemToJSON,
} from './OutputPositionStockStatisticsItem';

/**
 * 
 * @export
 * @interface OutputPositionStockStatistics
 */
export interface OutputPositionStockStatistics {
    /**
     * 
     * @type {Array<OutputPositionStockStatisticsItem>}
     * @memberof OutputPositionStockStatistics
     */
    items?: Array<OutputPositionStockStatisticsItem>;
}

/**
 * Check if a given object implements the OutputPositionStockStatistics interface.
 */
export function instanceOfOutputPositionStockStatistics(value: object): boolean {
    return true;
}

export function OutputPositionStockStatisticsFromJSON(json: any): OutputPositionStockStatistics {
    return OutputPositionStockStatisticsFromJSONTyped(json, false);
}

export function OutputPositionStockStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputPositionStockStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(OutputPositionStockStatisticsItemFromJSON)),
    };
}

export function OutputPositionStockStatisticsToJSON(value?: OutputPositionStockStatistics | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(OutputPositionStockStatisticsItemToJSON)),
    };
}

